import { BLOCKED_ITEM_FORM_CONDITIONS } from '@exam-center/blocked-user-management';
import { BlockedRecordBlockedScope } from '@exam-center/graphql';
import { z } from 'zod';

const BaseBlockedRecordStaffSchema = z.object({
  position: z.string().trim().nullish(),
  department: z.string().trim().nullish(),
  blockedCourses: z
    .object({
      type: z.nativeEnum(BlockedRecordBlockedScope).nullish(),
      courses: z.array(z.object({ value: z.string(), label: z.string() })).optional(),
    })
    .nullish(),
  enforcementEnd: z
    .object({
      assign: z.union([z.literal('true'), z.literal('false')]).nullish(),
      date: z.date().nullish(),
    })
    .nullish(),
  remark: z
    .string()
    .trim()
    .max(
      BLOCKED_ITEM_FORM_CONDITIONS.MAX_REASON_LENGTH,
      `ความยาวต้องไม่เกิน ${BLOCKED_ITEM_FORM_CONDITIONS.MAX_REASON_LENGTH} ตัวอักษร`,
    )
    .optional(),
});

export type BlockedRecordStaffFormInput = z.infer<typeof BaseBlockedRecordStaffSchema>;

function validateEnforcementEnd(data: BlockedRecordStaffFormInput, ctx: z.RefinementCtx) {
  const { enforcementEnd } = data;

  if (enforcementEnd?.assign === undefined || enforcementEnd?.assign === null) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'กรุณากำหนดวันที่สิ้นสุดปฏิบัติหน้าที่',
      path: ['enforcementEnd', 'assign'],
    });
    return;
  }

  if (enforcementEnd?.assign === 'true' && !enforcementEnd?.date) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'กรุณาเลือกวันที่สิ้นสุดปฏิบัติหน้าที่',
      path: ['enforcementEnd', 'date'],
    });
    return;
  }
}

function validateBlockedCourses(data: BlockedRecordStaffFormInput, ctx: z.RefinementCtx) {
  if (!data.blockedCourses?.type) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'กรุณากำหนดหลักสูตรที่ระงับสิทธิ์สอบ',
      path: ['blockedCourses', 'type'],
    });
    return;
  }

  if (data.blockedCourses?.type === BlockedRecordBlockedScope.PartialScope) {
    if (!data.blockedCourses.courses || data.blockedCourses.courses.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'กรุณาเลือกหลักสูตรที่ระงับสิทธิ์สอบ',
        path: ['blockedCourses', 'courses'],
      });
    }
  }
}

export const BlockedRecordStaffSchema = BaseBlockedRecordStaffSchema.superRefine((data, ctx) => {
  validateEnforcementEnd(data, ctx);
  validateBlockedCourses(data, ctx);
});
